import { TransportationStatus } from 'models/TransportationModel';
import { ApiBase } from 'utils/api';


export default class TransportationApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    all = (status: TransportationStatus) => this.base.axios
        .get(`/api/transportations`, {params: {status}})
        .then(res => res.data);

    setAgent = (agentId: number, transIds: number[]) => this.base.axios
        .put(`/api/transportations/agent/${agentId}`, {transIds});

    setPrice = (id: number, price: number) => this.base.axios
        .post(`/api/transport-order/${id}/price`, {price});

    load = (id: number) => this.base.axios
        .put(`/api/transportations/${id}/load`);

    loadMany = (ids: number[]) => this.base.axios
        .put(`/api/transportations/load`, {ids});

    deliver = (id: number) => this.base.axios
        .put(`/api/transport-order/${id}/deliver`);

    downloadList = (from: number, to: number, agent: number) => this.base.axios
        .get(`/api/transportations/list/f`, {
            params: {from, to, agent},
            responseType: 'blob',
        });

    downloadOrder = (id: number) => this.base.axios
        .get(`/api/transport-order/${id}/f`, {
            responseType: 'blob',
        });

    cancel = (id: number, reason: string) => this.base.axios
        .put(`/api/transportations/${id}/cancel`, {reason});
}
